import React from 'react';
import {
	summary,
	way,
	prizeinfo,
	fee,
	refundPolicy,
	mobileFee,
	mobileDeposit,
	groupBoothinfo,
} from './data';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container} from '../../../Components/Atom';

const Summary = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '대회요강']} />
			<CardSection {...summary} />
			<CardSection {...fee} />
			<CardSection {...mobileFee} />
			<CardSection {...mobileDeposit} />
			<CardSection {...refundPolicy} />
			<CardSection {...way} />
			<CardSection {...prizeinfo} />
			<CardSection {...groupBoothinfo} />
		</Container>
	);
};

export default Summary;
